export function getFileTypeIcon(fileType) {
    var data = {
        icon: '',
        color: ''
    }
    switch(fileType) {
        case 'Pdf':
            data.icon = 'fa-regular fa-file-pdf'
            data.color = 'red'
            break;
        case 'WordDocument':
            data.icon = 'fa-solid fa-file-word'
            data.color = 'blue'
            break;
        case 'Image':
            data.icon = 'fa-solid fa-file-image'
            data.color = 'green'
            break;
    }
    return data
}